import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Link from 'next/link';
import { faDesktop, faLaptop, faMobileAlt, faTabletAlt, faTv } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { IUserInfo } from '~/src/store/slices/authSlice';
import { StyledContainer } from './styled';

import logo from '~/public/logo.png';

interface ILayoutProps {
    userInfo?: IUserInfo;
    onLogout: () => void;
    middleButtons?: JSX.Element;
    rightButtons?: JSX.Element;

    children?: any;
}

export interface IBreakpoint {
    name: string;
    width: string;
    icon: IconDefinition;
}

export const iconsBreakpoints: IBreakpoint[] = [
    {
        name: 'desktop',
        width: '1919px',
        icon: faTv,
    },
    {
        name: 'wDesktop',
        width: '1649px',
        icon: faDesktop,
    },
    {
        name: 'sDesktop',
        width: '1365px',
        icon: faLaptop,
    },
    {
        name: 'tablet',
        width: '1023px',
        icon: faTabletAlt,
    },
    {
        name: 'mobile',
        width: '767px',
        icon: faMobileAlt,
    },
];

const Layout = ({
    userInfo,
    onLogout,
    children,
    middleButtons,
    rightButtons,
                }: ILayoutProps): JSX.Element => {
    return (
        <StyledContainer fluid>
            <Navbar bg='dark' variant='dark'>
                <Link href='/admin' passHref>
                    <Navbar.Brand className='mr-sm-3'>
                        <img src={`${logo}`} alt=''/>
                    </Navbar.Brand>
                </Link>
                <Nav className='mx-auto'>
                    {middleButtons}
                </Nav>
                <Nav>
                    {rightButtons}
                    <NavDropdown
                        title={userInfo?.name ?? 'Гость'}
                        id='nav-username'
                        alignRight
                    >
                        <NavDropdown.Item eventKey='4.1' onClick={onLogout}>
                            Выход
                        </NavDropdown.Item>
                    </NavDropdown>
                </Nav>
            </Navbar>
            {children}
        </StyledContainer>
    );
};

export default Layout;
